import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalComponent } from '../../../core/components/modal/modal.component';
import { ActivatedRoute } from '@angular/router';
import { LiftBoardParameterService } from '../../services/lift-board-parameter.service';
import { EntityListRefresh } from '../../../core/services/entity-list.refresh';
import { UINotificationService } from '../../../core/services/ui-notification.service';
import { NotificationType } from '../../../core/models/ui-notification.model';

@Component({
  selector: 'app-create-lift-board-parameter-group',
  templateUrl: './create-lift-board-parameter-group.component.html',
  styleUrls: ['./create-lift-board-parameter-group.component.css']
})
export class CreateLiftBoardParameterGroupComponent implements OnInit {
  form = new FormGroup({});
  liftBoardId: number;
  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  constructor(
    private route: ActivatedRoute,
    private parameterService: LiftBoardParameterService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.form.addControl('title', new FormControl('', Validators.required));

    this.liftBoardId = +this.route.snapshot.paramMap.get('boardId');
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid) {
      const lookupLang = [
        { twoLetterISOLanguageName: 'cs', title: this.form.get('title').value, description: this.form.get('title').value },
        { twoLetterISOLanguageName: 'de', title: this.form.get('title').value, description: this.form.get('title').value },
        { twoLetterISOLanguageName: 'en', title: this.form.get('title').value, description: this.form.get('title').value }
      ];

      this.parameterService.create({
        liftBoardId: this.liftBoardId,
        parentId: null,
        liftParameterId: null,
        values: null,
        language: lookupLang
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-board-parameter');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Skupina parametrů byla přidána'
        });
        modal.closeModal(null);
      });
    }
  }

}
